import { application } from "./controllers/application"

import SpiderHighChartController from "./controllers/spider_high_chart_controller"
application.register("spider-high-chart", SpiderHighChartController)
